import { render, staticRenderFns } from "./AdSpot2.vue?vue&type=template&id=c8bb8702&scoped=true"
import script from "./AdSpot2.vue?vue&type=script&lang=js"
export * from "./AdSpot2.vue?vue&type=script&lang=js"
import style0 from "./AdSpot2.vue?vue&type=style&index=0&id=c8bb8702&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bb8702",
  null
  
)

export default component.exports